import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getRequest } from "../../apis/ApiInstence";

const monthLabels = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec"
];

const SalesChart = () => {

  const [type, setType] = useState("month"); // day | month | year
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState("");
  const [chartData, setChartData] = useState([]);
  const [categories, setCategories] = useState([]);

  const fetchSalesData = async () => {
    try {
      const params = new URLSearchParams({ type, year });
      if (type === "day" && month) params.append("month", month);

      const res = await getRequest(`order/salesanalytics?${params}`);
      const data = res?.data?.data || [];

      if (type === "month") {
        setCategories(monthLabels);
        const filled = Array(12).fill(0);
        data.forEach(d => filled[d.label - 1] = d.total);
        setChartData(filled);
      }

      if (type === "day") {
        setCategories(data.map(d => `Day ${d.label}`));
        setChartData(data.map(d => d.total));
      }

      if (type === "year") {
        setCategories(data.map(d => d.label));
        setChartData(data.map(d => d.total));
      }

    } catch (err) {
      console.error("❌ Failed to fetch sales data:", err);
    }
  };

  useEffect(() => {
    fetchSalesData();
  }, [type, year, month]);

  const options = {
    chart: { type: "column" },
    title: { text: "Sales Analytics" },
    subtitle: { text: "Revenue in INR" },
    xAxis: { categories, crosshair: true },
    yAxis: {
      min: 0,
      title: { text: "Sales (₹)" }
    },
    tooltip: {
      pointFormat: "<b>₹{point.y}</b>"
    },
    series: [{
      name: "Sales",
      data: chartData
    }]
  };

  return (
    <div className="card p-3">
      {/* FILTER BAR */}
      <div className="d-flex mb-3">
        <select className="form-control mr-2" value={type} onChange={e => setType(e.target.value)}>
          <option value="day">Day Wise</option>
          <option value="month">Month Wise</option>
          <option value="year">Year Wise</option>
        </select>

        <select className="form-control mr-2" value={year} onChange={e => setYear(e.target.value)}>
          {[2025, 2026, 2027].map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>

        {type === "day" && (
          <select className="form-control" value={month} onChange={e => setMonth(e.target.value)}>
            <option value="">Select Month</option>
            {monthLabels.map((m, i) => (
              <option key={i} value={i + 1}>{m}</option>
            ))}
          </select>
        )}
      </div>

      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default SalesChart;
